export default "__VITE_ASSET__4LnXbufC__"